import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  BackofficeFlagsTimelineResponseDataSchema,
  DataResponse,
  GetBackofficeFlagsTimelineSchema,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof GetBackofficeFlagsTimelineSchema>
type Response = DataResponse<z.infer<typeof BackofficeFlagsTimelineResponseDataSchema>>

export const getBackofficeFlagsTimelineQuery = ({ query }: { query: Query }) =>
  queryOptions({
    queryKey: ["backofficeFlagsTimeline", query],
    queryFn: async () => {
      const { data } = await axios.get<Response>("/backoffice/flags/timeline", { params: query })
      return data.data
    },
  })
